import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { EstadosReglas } from '../_models/estados-reglas';

@Injectable( {
  providedIn: 'root'
} )
export class EstadosReglasService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/estadosReglas';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as EstadosReglas[] ) );
  }

  crear( regCrear: EstadosReglas ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as EstadosReglas ) );
  }

  actualizar( regActualizar: EstadosReglas ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

}
